const handleApiError = async (response) => {
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      window.location.reload();
      throw new Error('Oturum süresi doldu veya yetkiniz yok.');
    }
    const errorData = await response.json();
    throw new Error(errorData.message || 'Hata oluştu');
  }
};

export const fetchBuildings = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/buildings`, {
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
  return response.json();
};

export const addBuilding = async (buildingData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/buildings`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(buildingData),
  });
  await handleApiError(response);
  return response.json();
};

export const updateBuilding = async (buildingId, buildingData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/buildings/${buildingId}`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(buildingData),
  });
  await handleApiError(response);
  return response.json();
};

export const deleteBuilding = async (buildingId) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/buildings/${buildingId}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
};
